const ADD_INDICATION = '@@indications/ADD_INDICATION';
const REMOVE_INDICATION = '@@indications/REMOVE_INDICATION';
const ADD_STATIC_INDICATION = '@@indications/ADD_STATIC_INDICATION';
const REMOVE_STATIC_INDICATION = '@@indications/REMOVE_STATIC_INDICATION';
const RESET_INDICATIONS = '@@indications/RESET_INDICATIONS';

export { ADD_INDICATION, REMOVE_INDICATION, ADD_STATIC_INDICATION, REMOVE_STATIC_INDICATION, RESET_INDICATIONS };
